<template>
  <div class="tab-pane fade" id="emp_assets">
    <div class="showentries mb-3">
      <label
        >Show
        <select>
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        entries
      </label>
    </div>
    <div class="table-responsive table-newdatatable">
      <a-table
        class="stripped table-hover"
        :columns="columns"
        :data-source="data"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'id'">
            {{ getSerialNumber(record) }}
          </template>
          <template v-if="column.key === 'action'">
            <div class="table-actions d-flex justify-content-center">
              <a
                class="delete-table me-2"
                href="javascript:;"
                @click="selectedAssetDetails(record.id)"
                data-bs-toggle="modal"
                data-bs-target="#asset_details_modal"
              >
                <img
                  :src="require(`@/assets/img/icons/eye.svg`)"
                  alt="Eye Icon"
                />
              </a>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>

  <!-- Asset Details Modal -->
  <div class="modal custom-modal fade" id="asset_details_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Asset Details</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6 d-flex">
                <img
                  :src="
                    assetDetails.picture != null
                      ? assetDetails.picture.path
                      : 'https://techarc.pk/wp-content/uploads/2021/09/Logitech-M100R-0.jpg'
                  "
                  alt="Asset Picture"
                />
              </div>
              <div class="col-6">
                <div class="row mb-3">
                  <div class="col-6">Asset Name:</div>
                  <div class="col-6">
                    <h4>{{ assetDetails.product_name }}</h4>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-6">Price:</div>
                  <div class="col-6">
                    <h4>${{ assetDetails.price }}</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">Code:</div>
                  <div class="col-6">
                    <h4>{{ assetDetails.code }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Asset Details Modal -->
</template>
<script>
import MyAssetService from "@/services/MyAssetService";
const columns = [
  {
    title: "Id ",
    dataIndex: "id",

    sorter: {
      compare: (a, b) => {
        a = a.id;
        b = b.id;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Asset Name",
    dataIndex: "product_name",
    sorter: {
      compare: (a, b) => {
        a = a.product_name.toLowerCase();
        b = b.product_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Asset ID",
    dataIndex: "asset_id",
    sorter: {
      compare: (a, b) => {
        a = a.asset_id.toLowerCase();
        b = b.asset_id.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Asset Serial No & Pin",
    dataIndex: "asset_serial_no_pin",
    sorter: {
      compare: (a, b) => {
        a = a.asset_serial_no_pin.toLowerCase();
        b = b.asset_serial_no_pin.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Assigned By",
    dataIndex: "assigned_by_name",
    sorter: {
      compare: (a, b) => {
        a = a.assigned_by_name.toLowerCase();
        b = b.assigned_by_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Assigned Date",
    dataIndex: "issuance_date",
    sorter: {
      compare: (a, b) => {
        a = a.issuance_date.toLowerCase();
        b = b.issuance_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Asset Details",
    key: "action",
    sorter: true,
    class: "text-end",
  },
];
export default {
  data() {
    return {
      columns,
      data: [],
      selectedAsset: {},
      assetDetails: {},
    };
  },

  methods: {
    getSerialNumber(record) {
      const index = this.filteredData?.findIndex(
        (item) => item.id === record.id
      );
      return index + 1;
    },
    selectedAssetDetails(id) {
      this.selectedAsset = this.data.find((asset) => asset.id === id);
      this.assetDetails = this.selectedAsset.asset_detail;
    },
  },

  async created() {
    try {
      const response = await MyAssetService.getAssets();
      this.data = response.data;
    } catch (error) {
      console.log("error fetching assets", error);
    }
  },
};
</script>

<style scoped>
#asset_details_modal img {
  height: 200px;
  width: 200px;
  border: 1px solid #ddd;
  border-radius: 12px;
}
</style>
